import { render, staticRenderFns } from "./CardTarjaFutebolTVFechada.vue?vue&type=template&id=de0f9034&scoped=true"
import script from "./CardTarjaFutebolTVFechada.vue?vue&type=script&lang=js"
export * from "./CardTarjaFutebolTVFechada.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaFutebolTVFechada.vue?vue&type=style&index=0&id=de0f9034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0f9034",
  null
  
)

export default component.exports